import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const OutsourcingProvider5 = props => (
    <section id="outsourcing-provider-section5" className="my pt-5">
        <div className='blue-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingProvider:section-5.title')}</h2>
            <div className="AccordionUI bg p-5 mb-5">
                {[1, 2].map(item => (
                    <div key={item} className={item < 2 ? 'mb-5' : ''}>
                        <div className='d-flex align-items-center mb-4'>
                            <div className='arrow-container'>
                                <div className='arrow orange'>
                                    <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                                </div>
                            </div>
                            <h3 className='h5 fw-600 m-0 orange'>{props.t('services:outsourcingProvider:section-5.' + item + '.title')}</h3>
                        </div>
                        <p className={item < 2 ? '' : 'm-0'}><Trans i18nKey={'services:outsourcingProvider:section-5.' + item + '.text'} components={{ br: <br /> }} /></p>
                    </div>
                ))}
            </div>
            <p className='m-0'>{props.t('services:outsourcingProvider:section-5.text')}</p>
        </Container>
    </section>
);

export default OutsourcingProvider5;
